<template>
  <div :class="['dial-info', programStyle]">
    <div class="dial-header">{{ period }} {{ dialInfo.dialName }}</div>
    <!-- <span class="dial-type">{{ dialInfo.dialType }}</span> -->
    <div class="dealer-message" v-if="dialInfo.dealerMessage">
      {{ dialInfo.dealerMessage }}
    </div>
    <div class="top-messages">
      <div v-if="dialInfo.properties.messageTop1">{{ dialInfo.properties.messageTop1 }}</div>
      <div v-if="dialInfo.properties.messageTop2">{{ dialInfo.properties.messageTop2 }}</div>
    </div>
    <FD v-if="dialInfo.dialType === 'FD1'" :dialInfo="dialInfo"></FD>
    <FG v-if="dialInfo.dialType === 'FG'" :dialInfo="dialInfo"></FG>
    <MLT v-if="dialInfo.dialType === 'MLT1'" :dialInfo="dialInfo"></MLT>
    <MSM v-if="dialInfo.dialType === 'MSM1'" :dialInfo="dialInfo"></MSM>
    <RM v-if="dialInfo.dialType === 'RM1'" :dialInfo="dialInfo"></RM>
    <SM v-if="dialInfo.dialType === 'SM1'" :dialInfo="dialInfo"></SM>
    <ST v-if="dialInfo.dialType === 'ST'" :dialInfo="dialInfo"></ST>
    <SMMT v-if="dialInfo.dialType === 'SMMT' || dialInfo.dialType === 'FDMT'" :dialInfo="dialInfo"></SMMT>
    <div class="footer-info">
      <div
        v-if="
          dialInfo.properties.requirements1 || dialInfo.properties.requirements2 || dialInfo.properties.requirements3
        "
      >
        <div v-if="dialInfo.properties.requirements1">
          <span v-html="dialInfo.properties.requirements1"></span>
        </div>
        <div v-if="dialInfo.properties.requirements2">
          <span v-html="dialInfo.properties.requirements2"></span>
        </div>
        <div v-if="dialInfo.properties.requirements3">
          <span v-html="dialInfo.properties.requirements3"></span>
        </div>
      </div>
      <div class="margin-top" v-if="dialInfo.dealerMessageBottom">
        <span v-html="dialInfo.dealerMessageBottom"> </span>
      </div>
      <div class="margin-top" v-if="dialInfo.properties.messageBottom1 || dialInfo.properties.messageBottom2">
        <div v-if="dialInfo.properties.messageBottom1">
          <span v-html="dialInfo.properties.messageBottom1"></span>
        </div>
        <div v-if="dialInfo.properties.messageBottom2"><span v-html="dialInfo.properties.messageBottom2"> </span></div>
      </div>
      <div class="margin-top" v-if="dialInfo.properties.dataUpdatedDate">
        <div v-if="dialInfo.properties.dataUpdatedDate">
          {{ $t('data-last-updated', [dialInfo.properties.dataUpdatedDate]) }}
        </div>
        <div v-if="dialInfo.properties.targetLockDate">
          {{ $t('data-update-frequency', [dialInfo.properties.dataUpdateFrequency]) }}
        </div>
      </div>
      <div class="margin-top" v-if="dialInfo.properties.dataMessage1 || dialInfo.properties.dataMessage2">
        <div v-if="dialInfo.properties.dataMessage1">
          <span v-html="dialInfo.properties.dataMessage1"></span>
        </div>
        <div v-if="dialInfo.properties.dataMessage2">{{ dialInfo.properties.dataMessage2 }}</div>
      </div>
      <div
        class="margin-top"
        v-if="
          dialInfo.properties.targetMethod && dialInfo.properties.targetUpdateDate && dialInfo.properties.targetLockDate
        "
      >
        <div v-if="dialInfo.properties.targetUpdateDate">
          {{ dialInfo.properties.targetMethod }} Target Updated On: {{ dialInfo.properties.targetUpdateDate }}
        </div>
        <div v-if="dialInfo.properties.targetLockDate">
          {{ dialInfo.properties.targetMethod }} Target Locked On: {{ dialInfo.properties.targetLockDate }}
        </div>
      </div>
    </div>
    <FDMT v-if="dialInfo.dialType === 'FDMT'" :dialInfo="dialInfo"></FDMT>
  </div>
</template>

<script>
import FD from '@/components/Dials/FD.vue';
import FG from '@/components/Dials/FG.vue';
import MLT from '@/components/Dials/MLT.vue';
import MSM from '@/components/Dials/MSM.vue';
import RM from '@/components/Dials/RM.vue';
import SM from '@/components/Dials/SM.vue';
import ST from '@/components/Dials/ST.vue';
import SMMT from '@/components/Dials/SMMT.vue';
import FDMT from '@/components/Dials/FDMT.vue';
import { mapState } from 'vuex';

export default {
  name: 'default',
  components: {
    FD,
    FG,
    MLT,
    MSM,
    RM,
    SM,
    ST,
    SMMT,
    FDMT,
  },
  props: {
    dialInfo: {
      type: Object,
    },
    period: {
      type: String,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState('global', ['programStyle']),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.dial-info {
  display: flex;
  flex-direction: column;
  overflow: auto;
  .dial-header {
    font-size: 20px;
    font-weight: bold;
    line-height: 26px;
    color: $primary;
    text-transform: uppercase;
    text-align: left;
  }
}
.dealer-message {
  margin-top: 10px;
  text-align: left;
  font-size: 12px;
  color: black;
  display: flex;
}
.header {
  display: flex;
  justify-content: flex-start;
  font-size: 18px;
  font-weight: 100;
  color: #243882;
}
.dial-type {
  text-align: left;
  font-size: 12px;
  color: #243882;
  display: flex;
}
.top-messages {
  color: black;
  font-size: 16px;
  text-align: left;
  margin-top: 10px;
}
.details {
  display: flex;
  margin-top: 17px;
  div {
    display: flex;
    flex-direction: column;
    margin-right: 45px;
    .title {
      color: #1d1d1b;
      font-size: 12px;
    }
    .number {
      font-size: 21px;
    }
  }
}
.table-container {
  margin-top: 28px;
  display: flex;
  .left-table {
    display: flex;
    margin-right: 40px;
    margin-top: 30px;
    .row {
      display: flex;
      flex-direction: column;
      .header {
        background-color: #898c8d;
        color: white;
        padding: 10px 12px;
        font-size: 14px;
      }
      .data {
        color: #1d1d1b;
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }
  .right-table {
    display: flex;
    flex-direction: column;
    .table-header {
      color: #ffffff;
      background-color: #898c8d99;
      padding: 5px 0;
      height: 20px;
    }
    .right-table-container {
      display: flex;
      .row {
        display: flex;
        flex-direction: column;
        .header {
          background-color: #898c8d;
          color: white;
          padding: 10px 12px;
          font-size: 14px;
        }
        .data {
          color: #1d1d1b;
          font-size: 14px;
          margin-top: 10px;
          height: 16px;
        }
      }
    }
  }
}
.footer-info {
  font-size: 12px;
  color: #1d1d1b;
  margin-top: 17px;
  align-items: flex-start;
  text-align: left;
}
.margin-top {
  margin-top: 10px;
}
</style>
